import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/layout';
import SEO from 'react-seo-component';

import card1Img from '../images/card1.png';
import card2Img from '../images/card2.png';
import card3Img from '../images/card3.png';
import FlourishLineLeft from "../images/flourish-lines-left.png";
import FlourishLineRight from "../images/flourish-lines-right.png";

const Gateway360 = props => {

    const OpenLogin = (e) => {
        e.preventDefault()
        const loginOverflow = document.getElementsByClassName("login_overflow")[0];
        loginOverflow.classList.add("active");
    }

    const data = {}
    return (
        <Layout>
            <SEO
                title="360 Gateway"
                titleTemplate={data.default_title || "eScript360"}
                description={
                    data.default_description ||
                    'No copays, deductibles, prior authorizations, or pre-approvals. Welcome to Pharmacy Redefined.'
                }
                image={'src/images/eScript.logo.png'}
                pathname="https://www.escript360.com/360-gateway"
                siteLanguage="en-US"
                siteLocale="en_us"
                twitterUsername="@escript360"
            />
            {
                <section className='gataway_page'>
                    <img className='left_image'
                        src={FlourishLineLeft}
                        alt="Flourished lines"
                    />
                    <img className="right_image"
                        src={FlourishLineRight}
                        alt="On the go"
                    />
                    <h1 className='title_main'>360 Gateway</h1>
                    <h3 className='under_title'>The 360 Gateway welcomes patients, providers, and payers<br />
                        participating in an eScript360 program.</h3>
                    <div className='cards_content'>
                        <div className='card_gate'>
                            <img src={card1Img} alt='' />
                            <div className='content'>
                                <div className='heading'>
                                    I am a Patient
                                </div>
                                <ul>
                                    <li>Enroll in a program</li>
                                    <li>Access the status of my prescription</li>
                                    <li>Request a refill</li>
                                    <li>Request information</li>
                                    <li>Request to speak to a clinician /pharmacist</li>
                                    <li>Update my contact information</li>
                                </ul>
                                <a href='/' onClick={(e) => OpenLogin(e)}>Proceed</a>
                            </div>
                        </div>
                        <div className='card_gate'>
                            <img src={card2Img} alt='' />
                            <div className='content'>
                                <div className='heading'>
                                    I am a Provider
                                </div>
                                <ul>
                                    <li>Enroll a Patient</li>
                                    <li>Adjust Patient’s medication therapy</li>
                                    <li>ePA document update</li>
                                    <li>eBV benefits update</li>
                                    <li>View patient history</li>
                                    <li>Update my contact information</li>
                                </ul>
                                <a href='/' onClick={(e) => OpenLogin(e)}>Proceed</a>
                            </div>
                        </div>
                        <div className='card_gate'>
                            <img src={card3Img} alt='' />
                            <div className='content'>
                                <div className='heading'>
                                    I am a Payer
                                </div>
                                <ul>
                                    <li>Access data analytics</li>
                                    <li>Custom reporting</li>
                                    <li>Remittance/Reimbursement</li>
                                    <li>Program changes</li>
                                </ul>
                                <a href='/' onClick={(e) => OpenLogin(e)}>Proceed</a>
                            </div>
                        </div>
                    </div>
                    <div className='under_text'>
                        <p>If you don’t have an account, contact us now</p>
                        <a href='/join-us#contact' className='pink_btn'>Create a new account</a>
                    </div>
                </section>
            }

        </Layout>
    );
}

export default Gateway360;

export const query = graphql`  
{prismic {
    allJoin_uss {
      edges {
        node {
          title
          text
          _linkType
        }
      }
    }
  }
}`;
